module.exports = __webpack_public_path__ + "static/media/logomercenaries.66067421.png";


//////////////////
// WEBPACK FOOTER
// ./src/logomercenaries.png
// module id = 26
// module chunks = 0